import React, { memo, useEffect, useState } from "react";
import { Form, Input, Row, Col, Button, Modal, Spin, Divider } from "antd";
import executionService from "../../services/executionService";
import toastNotification from "../../components/toastNotification";
import { useParams } from "react-router-dom";
import FormSelect from "./Partial/FormSelect";
const { confirm } = Modal;

const AddPhasePage = memo(
  ({
    addNewItem,
    updateCurrentItem,
    editRecord,
    updatedData,
    hideItem,
    currentIndex,
    parentIndex,
    staticItems,
    getIndexOnCreate,
    isPageReadOnly,
  }) => {
    const { procedureid } = useParams();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const addProcedurePhase = async (phaseFormValues) => {
      setLoading(true);
      phaseFormValues.procedure = procedureid;
      const index = getIndexOnCreate(staticItems, "phase", parentIndex);
      phaseFormValues.index = index;
      const res = await executionService.postPhase(phaseFormValues);
      if (res.status === 200) {
        toastNotification("success", "New Phase Added");
        let item = {
          id: new Date().getTime(),
          phase: res.data.id,
          content: res.data.phaseName,
          original: res.data,
          current: currentIndex,
          parent: parentIndex,
        };
        addNewItem(item);
      } else {
        toastNotification("error", "Error adding a new phase record");
      }
      setLoading(false);
    };

    const editPhase = async (phaseFormValues) => {
      setLoading(true);
      phaseFormValues.procedure = procedureid;
      const res = await executionService.putPhase(
        phaseFormValues,
        editRecord.phase
      );
      if (res.status === 200) {
        toastNotification("success", "Phase Updated Successfully");
        updateCurrentItem(null);
        updatedData();
      } else {
        toastNotification("error", "Error updating the procedure record");
      }
      setLoading(false);
    };
    const onFinish = (phaseFormValues) => {
      phaseFormValues.procedure = procedureid;
      // phaseFormValues.index = index;
      if (editRecord.phase) {
        editPhase(phaseFormValues);
      } else {
        addProcedurePhase(phaseFormValues);
      }
    };

    useEffect(() => {
      if (editRecord) {
        form.setFieldsValue(editRecord.original);
      }
    }, []);

    const deletePhase = async (id) => {
      setLoading(true);
      const isDeleted = await executionService.deletePhase(editRecord.phase);
      if (isDeleted) {
        toastNotification("success", "Phase deleted successfully");
        updateCurrentItem(null);
        updatedData();
      } else {
        toastNotification("error", "Error deleting the phase");
      }
      setLoading(false);
    };

    const showDeleteConfirmation = (id) => {
      confirm({
        title: <h2 className="delete-notes">Delete Phase</h2>,
        content: (
          <div>
            <div>
              Tapping on "Confirm" would delete this not from the execution
              flow.
            </div>
            <div>Are you sure you want to continue?</div>
          </div>
        ),
        okText: "Confirm",
        cancelText: "Cancel",
        centered: true,
        icon: <></>,
        onOk() {
          deletePhase(id);
        },
      });
    };

    return (
      <Spin spinning={loading}>
        <Form
          form={form}
          name="AddPhaseStepsAddEditForm"
          id="AddPhaseStepsAddEditForm"
          size="large"
          colon="false"
          scrollToFirstError="true"
          onFinish={onFinish}
          layout="vertical"
        >
          <Row gutter={[0, 8]}>
            <Col span={12}>
              <FormSelect
                updateCurrentItem={updateCurrentItem}
                selectedValue="PHASE"
                editRecord={editRecord}
              />
            </Col>
            <Col lg={12} style={{ textAlign: "right" }}>
              {!isPageReadOnly && (
                <Form.Item>
                  {editRecord && (
                    <Button
                      style={{ marginRight: "0" }}
                      type="secondary"
                      onClick={() => {
                        showDeleteConfirmation(editRecord.phase);
                      }}
                      className="delete-btn-none"
                    >
                      Delete
                    </Button>
                  )}
                  {!editRecord && (
                    <Button
                      style={{ marginRight: "0" }}
                      type="default"
                      htmlType="button"
                      className="delete-btn-none"
                      onClick={hideItem}
                    >
                      Close
                    </Button>
                  )}

                  <Button
                    style={{ marginRight: "0" }}
                    type="primary"
                    htmlType="submit"
                  >
                    Save
                  </Button>
                </Form.Item>
              )}
            </Col>
          </Row>
          <Divider
            type="horizontal"
            style={{
              margin: "-5px",
            }}
          />
          <Row className="margin-top-notes">
            <Col span={2}></Col>
            <Col span={21}>
              <Form.Item
                label="Label (Required)"
                name="phaseName"
                required
                rules={[
                  {
                    required: true,
                    message: "Please input Phase name!",
                  },
                ]}
              >
                <Input placeholder="Phase Name" disabled={isPageReadOnly} />
              </Form.Item>
            </Col>
            <Col span={1}></Col>
          </Row>
        </Form>
      </Spin>
    );
  }
);

export default AddPhasePage;
